export function finishFormTrack() {
  if (window.fbq) {
    console.log("fb:track");
    window.fbq("track", "CompleteRegistration", {
      content_name: "submit",
      status: true,
      value: 1,
      custom_event_type: "COMPLETE_REGISTRATION",
    });
  }
}
